module.exports = __webpack_public_path__ + "img/05_kudo_12.61696bfb.jpg";